// extracted by mini-css-extract-plugin
export default {"container":"MapInfo_container__zmBzK","tabs":"MapInfo_tabs__K1P5F"};